import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-rentwise-records',
  templateUrl: './rentwise-records.component.html',
  styleUrls: ['./rentwise-records.component.css']
})
export class RentwiseRecordsComponent implements OnInit {
  users: any[] = [];


  requestedUser : any = {
    "email" : "",
    "progress" : "",
    "completionDate": null
  }
  requestedStatus: any;

  constructor(private userService: UserService) { }

  ngOnInit(): void {
    this.userService.getRentwisePublic().toPromise().then((res: any) => {
      this.users = res.users;
    });
  }

  userSearch: string = '';
  search: boolean = false;
  isCompleted: boolean|null = null;

  onChangeEvent(event: any) {
    this.search = false;
    this.requestedUser.email = '';
    this.requestedUser.progress = '';
    this.isCompleted = null;
  }

  async searchUser() {
    this.search = true;
    this.isCompleted = null;
    this.requestedUser.email = this.userSearch.toLowerCase();
    this.requestedUser.completionDate = null;

    // Loop through all registered users
    for (var i = 0; i < this.users.length; i++ )
    {
      // If user is found, evaluate RentWise progress
      if (this.users[i].email.toLowerCase().trim() == this.userSearch.toLowerCase().trim())
      {
        const res: any = await this.userService.getRentwiseProgress(this.users[i]._id).toPromise();

        this.isCompleted = !!res.progress.isCompleted;

        if (this.isCompleted) {
          this.requestedUser.progress = "Completed";
          this.requestedUser.completionDate = res.progress.completionDate;
          return;
        }
      }
    }

    // Default case - user is never found
    this.requestedUser.progress = "This person has not passed RentWise course";
    this.isCompleted = false;
  }
}
